// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  margin-bottom: 10px;
  position: relative;
}
:host.not-applicable {
  text-decoration: line-through;
}
:host.not-applicable.hide-not-applicable {
  display: none !important;
}
:host ::ng-deep .mat-mdc-card-header-text {
  margin: 0;
  width: 100%;
}

a {
  display: block;
  text-decoration: none;
}

mat-card-title {
  display: grid;
  font-size: 14px;
  font-weight: 500;
  grid-template-columns: 1fr 40px;
  margin: 0;
}

mat-card-subtitle {
  font-size: 12px;
  margin: 0;
}

.mat-mdc-card-content {
  margin-bottom: 5px;
}

mat-card-actions {
  margin: 0;
}

.mat-mdc-card {
  padding: 10px;
}
@media print {
  .mat-mdc-card {
    border: solid 1px;
    box-shadow: none;
  }
}

.mat-mdc-card-header .mat-mdc-card-subtitle:not(:first-child) {
  margin-top: 0;
}

.mat-mdc-card > .mat-mdc-card-actions:last-child {
  margin-bottom: 0;
}

.card__actions {
  margin-top: 5px;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 10;
}

.card__subtitle {
  display: grid;
  grid-template-columns: 1fr auto;
}
.card__subtitle .card__versions {
  display: flex;
  justify-content: center;
}

::ng-deep o-revision-mark {
  display: flex;
  justify-content: center;
}
/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./apps/viewer/src/app/shared-module/card/card.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,mBAAA;EACA,kBAAA;AACF;AACE;EACE,6BAAA;AACJ;AAEE;EACE,wBAAA;AAAJ;AAII;EACE,SAAA;EACA,WAAA;AAFN;;AAOA;EACE,cAAA;EACA,qBAAA;AAJF;;AAOA;EACE,aAAA;EACA,eAAA;EACA,gBAAA;EACA,+BAAA;EACA,SAAA;AAJF;;AAOA;EACE,eAAA;EACA,SAAA;AAJF;;AAOA;EACE,kBAAA;AAJF;;AAOA;EACE,SAAA;AAJF;;AAOA;EACE,aAAA;AAJF;AAKE;EAFF;IAGI,iBAAA;IACA,gBAAA;EAFF;AACF;;AAKA;EACE,aAAA;AAFF;;AAKA;EACE,gBAAA;AAFF;;AAKA;EACE,eAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,WAAA;AAFF;;AAKA;EACE,aAAA;EACA,+BAAA;AAFF;AAIE;EACE,aAAA;EACA,uBAAA;AAFJ;;AAMA;EACE,aAAA;EACA,uBAAA;AAHF;AACA,4lFAA4lF","sourcesContent":[":host {\n  display: block;\n  margin-bottom: 10px;\n  position: relative;\n\n  &.not-applicable {\n    text-decoration: line-through;\n  }\n\n  &.not-applicable.hide-not-applicable {\n    display: none !important;\n  }\n\n  ::ng-deep {\n    .mat-mdc-card-header-text {\n      margin: 0;\n      width: 100%;\n    }\n  }\n}\n\na {\n  display: block;\n  text-decoration: none;\n}\n\nmat-card-title {\n  display: grid;\n  font-size: 14px;\n  font-weight: 500;\n  grid-template-columns: 1fr 40px;\n  margin: 0;\n}\n\nmat-card-subtitle {\n  font-size: 12px;\n  margin: 0;\n}\n\n.mat-mdc-card-content {\n  margin-bottom: 5px;\n}\n\nmat-card-actions {\n  margin: 0;\n}\n\n.mat-mdc-card {\n  padding: 10px;\n  @media print {\n    border: solid 1px;\n    box-shadow: none;\n  }\n}\n\n.mat-mdc-card-header .mat-mdc-card-subtitle:not(:first-child) {\n  margin-top: 0;\n}\n\n.mat-mdc-card > .mat-mdc-card-actions:last-child {\n  margin-bottom: 0;\n}\n\n.card__actions {\n  margin-top: 5px;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: 10;\n}\n\n.card__subtitle {\n  display: grid;\n  grid-template-columns: 1fr auto;\n\n  .card__versions {\n    display: flex;\n    justify-content: center;\n  }\n}\n\n::ng-deep o-revision-mark {\n  display: flex;\n  justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
